import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * @customElement cr-card-button
 */
@customElement('cr-card-button')
export class CrCardButton extends ChemistryLitElement {
  @property({ attribute: true, type: String }) public icon = '';
  @property({ attribute: true, type: String }) public label = '';
  @property({ attribute: false }) public iconPositionRight = true;

  override styles() {
    return [
      ...super.styles(),
      {
        'cr-card': {
          cursor: 'pointer',
          transition: 'all 0.25s ease-in-out',
          background: this.colors.primary.shade(300),
        },
        'cr-card:hover': {
          background: this.colors.primary,
        },
      },
    ];
  }

  override render() {
    return html`
      <cr-card w100 h100>
        <cr-flex flex center crossaxis-center horizontal space="sm">
          ${!this.iconPositionRight
            ? html` <cr-icon ${css({ color: 'white', fontSize: '1.4rem' })}>${this.icon}</cr-icon> `
            : nothing}
          <cr-h4 ${css({ color: 'white' })}>
            <slot></slot>
          </cr-h4>
          ${this.iconPositionRight
            ? html` <cr-icon ${css({ color: 'white', fontSize: '1.4rem' })}>${this.icon}</cr-icon> `
            : nothing}
        </cr-flex>
        ${this.label
          ? html`
              <cr-tooltip>
                <cr-text> ${this.label} </cr-text>
              </cr-tooltip>
            `
          : nothing}
      </cr-card>
    `;
  }
}
